export enum DistributionChannel {
  Email = 0,
  WebLink = 1,
  Kiosk = 2,
  Paper = 3,
}
